<script>
  import RateMaterials from "./../RateMaterial/RateMaterials.svelte";
  import { scale } from "svelte/transition";
  import { createEventDispatcher } from "svelte";
  import { onMount } from "svelte";
  import axios from "axios";
  import config from "../../../stores/config";
  import { Wave } from "svelte-loading-spinners";
  import * as ls from "local-storage";
  import loadData from "../../../utils/loadData";

  export let EDITABLE = false;

  let loading = true;
  let authData = { headers: { authorization: ls.get("jwt") } };

  export let show = false;
  export let title = "";

  export let styleID;

  let materialReq = null;

  const loadRating = async () => {
    loading = true;

    axios
      .get(`${$config.backendURL}/fstyles/${styleID}`, authData)
      .then((res) => {
        materialReq = res.data.materialReq;
        loading = false;
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const dispatch = createEventDispatcher();

  const onClose = () => {
    dispatch("modalClose");
  };

  onMount(async () => {
    loadRating();
  });
</script>

{#if show}
  <div
    on:click|self={onClose}
    class="fixed top-0 left-0 w-screen h-screen flex items-center justify-center bg-black/50"
    style="z-index: 999;"
  >
    <div
      transition:scale
      class="w-10/12 h-5/6 bg-gray-50 rounded-lg shadow-2xl py-4 px-5 border-t-2 border-brand overflow-auto"
    >
      <!-- Window title -->
      <div class="flex justify-between mb-4">
        <div class="flex items-center">
          <i class="fas fa-lightbulb mr-2 text-xl" />
          <div class="uppercase text-base flex items-center">
            REQUIREMENTS FOR
            <div class="flex items-center mx-1 text-red-500">ONE</div>
            {title}
          </div>
        </div>
        <div class="flex items-center justify-center">
          <button class="btn btn-primary" on:click={onClose}>
            <i class="fas fa-times-circle mr-2" />
            Close
          </button>
        </div>
      </div>

      <!-- Content -->
      <div class="">
        {#if loading}
          <div class="loading-screen h-screen flex items-center justify-center">
            <Wave size="100" color="rgb(244,162,97)" unit="px" />
          </div>
        {:else}
          <div class="">
            <RateMaterials
              {EDITABLE}
              {styleID}
              {materialReq}
              on:reloadData={() => {
                loadData();
                loadRating();
              }}
            />
          </div>
        {/if}
      </div>
    </div>
  </div>
{/if}
